import { jsxs as t, jsx as l } from "react/jsx-runtime";
const i = (a) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 24 24", ...a, children: [
  /* @__PURE__ */ l(
    "path",
    {
      fill: "#212134",
      d: "M17.756 5.748a3.416 3.416 0 0 0-4.747.467L12.01 7.41a.852.852 0 0 0 1.308 1.092l1-1.195a1.7 1.7 0 0 1 2.43-.18 1.735 1.735 0 0 1 .141 2.394l-2.077 2.486-.019.022a1.697 1.697 0 0 1-2.522.043.852.852 0 0 0-1.248 1.162 3.405 3.405 0 0 0 5.1-.137l2.071-2.48a3.502 3.502 0 0 0 .79-2.572 3.345 3.345 0 0 0-1.228-2.298Z"
    }
  ),
  /* @__PURE__ */ l(
    "path",
    {
      fill: "#212134",
      d: "m11.622 14.956-.893 1.069a1.735 1.735 0 0 1-2.381.286 1.7 1.7 0 0 1-.255-2.423l2.113-2.529.016-.017a1.692 1.692 0 0 1 2.552-.012.852.852 0 0 0 .999.205.841.841 0 0 0 .284-.22l.01-.012a.84.84 0 0 0-.014-1.1 3.4 3.4 0 0 0-5.16.07l-2.108 2.522a3.417 3.417 0 0 0 .385 4.754 3.346 3.346 0 0 0 2.48.8 3.501 3.501 0 0 0 2.39-1.234l.89-1.066a.852.852 0 1 0-1.308-1.093Z"
    }
  )
] }), e = i;
export {
  e as default
};
